import { get, post, put } from '../services/common/common.service';
import { sitesEndPoints } from '../constants/endpoint';

//entitlement summary tab
export const entitlementSummary = (payload) =>
  post(sitesEndPoints.entitlementSummary, payload);

//entitlement status
export const getEntitlementStatus = (payload) =>
  get(sitesEndPoints.entitlementStatus, payload);

//sites activity tab
export const getSiteActivityData = (payload) =>
  get(
    `${sitesEndPoints.siteActivity}?siteId=${payload.siteId}&RecordCount=${payload.recordCount}&PageIndex=${payload.pageIndex}`,
    payload
  );

export const getSiteSlesOrder = (payload) =>
  get(
    `${sitesEndPoints.siteSalesOrder}?siteId=${payload.siteId}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`,
    payload
  );

export const getSiteHistory = (payload) =>
  get(
    `${sitesEndPoints.siteHistory}?siteId=${payload.siteId}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`,
    payload
  );

//notes tab
export const getSiteNotes = (payload) => {
  return get(
    `${sitesEndPoints.siteNotes}?siteId=${payload.siteId}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`,
    payload
  );
};

export const addSiteNotes = (payload) =>
  post(sitesEndPoints.addSiteNotes, payload);

export const getSiteDetails = (siteId) =>
  get(`${sitesEndPoints.siteDetails}?siteCode=${siteId}`);

export const getPricingOptions = (contractId) =>
  get(`${sitesEndPoints.pricingOptions}?contractId=${contractId}`);

export const getSiteTypeOptions = () =>
  get(`${sitesEndPoints.siteTypeOptions}`);

export const fetchSites = (payload) => post(sitesEndPoints.siteSearch, payload);

export const fetchVantiveList = (payload) =>
  post(sitesEndPoints.siteVantiveList, payload);

export const getAccountingGroup = (customerId) =>
  get(`${sitesEndPoints.accountingGroup}?customerId=${customerId}`);

export const getSiteAccountingGroup = (siteId) =>
  get(`${sitesEndPoints.siteDetailswithCustomerBillInfo}?siteId=${siteId}`);

export const getAddress = (siteCode) =>
  get(`${sitesEndPoints.address}?siteCode=${siteCode}&sequenceNumber=2`);

export const getContract = (siteId) =>
  get(`${sitesEndPoints.contract}?siteId=${siteId}`);

export const updateSite = (payload) => put(sitesEndPoints.siteUpdate, payload);

//Entitlement Details tab
export const fetchSiteEntitlementDetailsData = (payload) => {
  return post(sitesEndPoints.siteEntitlementDetails, payload);
};

export const fetchSiteEntitlementCount = (payload) => {
  return post(sitesEndPoints.siteEntitlementCount, payload);
};

export const siteJobUpdateEntitlements = (payload) => {
  return post(`
${sitesEndPoints.siteJobUpdateEntitlements}?siteId=${payload.siteId}&userId=${payload.userId}`);
};

export const fetchEntitlementsStatus = (payload) => {
  return get(sitesEndPoints.siteEntitlementDetailsEntitlementStatus, payload);
};

//Sites : Site Activity Details
export const fetchSiteActivityDetailsData = (payload) => {
  return get(
    `${sitesEndPoints.siteActivityDetails}?siteId=${payload.siteId}&siteActivityId=${payload.siteActivityId}`,
    payload
  );
};

//Fetch Entitlement Details from Site Id and Site Activity Id
export const fetchEntitlementsbySiteId = (payload) => {
  return post(sitesEndPoints.entitlementsbySiteIdAndActivity, payload);
};

//Updating Site Activity Details (comments)
export const updateSiteActivityDetails = (payload) =>
  put(sitesEndPoints.updateSiteActivityDetails, payload);

export const fetchServiceProductData = (payload) => {
  return post(sitesEndPoints.updatedServiceProductSearchTempAdd, payload);
};

export const fetchServiceLevelData = () => {
  return get(sitesEndPoints.sevriceLevelData);
};

export const entitlementSummaryData = (payload) => {
  return post(sitesEndPoints.tempAddEntitlement, payload);
};

//API update contract history of all entitlement on a site
export const updateSiteEntitlementContractHistoryData = (payload) => {
  return post(`
${sitesEndPoints.updateSiteEntitlementsContract}?siteId=${payload.siteId}`);
};